"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalError = void 0;
const handled_error_1 = require("./handled.error");
class InternalError extends handled_error_1.HandledError {
    constructor(originalError, name) {
        super(originalError instanceof Error ? originalError.message : (originalError?.toString() ?? ''));
        this.originalError = originalError;
        this.name = name;
    }
}
exports.InternalError = InternalError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJuYWwuZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW50ZXJuYWwuZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbURBQThDO0FBRTlDLE1BQWEsYUFBYyxTQUFRLDRCQUFZO0lBQzdDLFlBQ2tCLGFBQXNCLEVBQ3RDLElBQVk7UUFFWixLQUFLLENBQUMsYUFBYSxZQUFZLEtBQUssQ0FBQyxDQUFDLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxhQUFhLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQTtRQUhqRixrQkFBYSxHQUFiLGFBQWEsQ0FBUztRQUl0QyxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtJQUNsQixDQUFDO0NBQ0Y7QUFSRCxzQ0FRQyJ9